<script>
export default {
    name: "InvestigationLabRequests",

    data() {

        return {
            investigations: [],
            patient: {},
            admissionDetails: {},
            printDate: window.moment()
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.all([ this.fetchInvestigation(), this.fetchPatient(), ]).then(() => {
                this.$root.loading=false;
                setTimeout(() => {
                    window.print();
                }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatientWithWard`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.patientDetails.length ?
                     response.data.patientDetails[0] : {};
                this.admissionDetails = response.data.admissionDetails.length ? 
                    response.data.admissionDetails[0] : {};
            }).catch(() => {});
        },

        fetchInvestigation() {
            let url = `Lab/GetPatientPendingSpecificLabInvestigation`;
                url += `?InvestigationID=${this.$route.params.investigationId}`;

            return this.$http.get(url).then(({ data }) => {
                this.investigations = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center mt-4">
            <h5 class="text-base font-bold uppercase">Lab Request</h5>
        </div>
        <div class="w-full flex flex-wrap mt-2">
            <div class="w-full flex flex-wrap p-1 my-1 border-b-2 border-t-2 border-gray-800">
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Name:</span> 
                        {{ patient.names }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">IP File No:</span> 
                    {{ patient.ipfileno || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">OP File No:</span> 
                    {{ patient.opfileno || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Visit No:</span> 
                    {{ patient.visitNo || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">MRN:</span> 
                        {{ patient.patienT_ID }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Age:</span> 
                        {{ patient.dob | numberOfYears }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Gender:</span> 
                        {{ patient.gender }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Ward:</span> 
                        {{ admissionDetails.ward || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Bed:</span> 
                        {{ admissionDetails.bed || `-` }}</h5>
                </div>
            </div>
            <div class="w-full overflow-auto my-2">
                <table class="table">
                    <tbody class="text-base overflow-visible">
                        <tr>
                            <th class="p-tiny">Code</th>
                            <th class="p-tiny">Req On</th>
                            <th class="p-tiny">Investigation</th>
                            <th class="p-tiny">Req By</th>
                            <th class="p-tiny">Is Urgent</th>
                            <th class="p-tiny">Comment</th>
                            <th class="p-tiny">Username</th>
                            
                        </tr>
                    </tbody>
                    <tbody 
                        v-for="(inv,idx) in investigations" :key="idx"
                        class="text-base overflow-visible">
                        <tr>
                            <td class="p-tiny">{{ inv.code }}</td>
                            <td class="p-tiny">{{ inv.date | dateFormat }}</td>
                            <td class="p-tiny">{{ inv.investigation }}</td>
                            <td class="p-tiny">{{ inv.requestedBy }}</td>
                            <td class="p-tiny">{{ inv.IsUrgent ? `Yes` : `-` }}</td>
                            <td class="p-tiny">{{ inv.memo || `-` }}</td>
                            <td class="p-tiny">{{ inv.userName || `-` }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
